import React, { useState } from 'react'
import parse from 'html-react-parser';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography'
import Popup from './Popup';
import ContactUs from "./ContactUs";
import TandC from './TandC';
import Privacy from "./Privacy";
import Refund from "./Refund";

const CustomFooter = (props)  => {
    const uiConfig = props.uiConfig;
    const [popupOpen, setPopupOpen] = useState(false);
    const [component, setComponent] = useState(null);
    const [title, setTitle] = useState('');

    const setDone = () => {
        setPopupOpen(false);
        setComponent(null);
        setTitle('');
    }

    const openPopup = (comp, popupTitle) => {
        setComponent(comp);
        setTitle(popupTitle);
        setPopupOpen(true);
    }

    const handleKeyDown = (event, comp, popupTitle) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            openPopup(comp, popupTitle);
        }
    }

    return (
        <>
            { popupOpen &&
                <Popup open={popupOpen} setDone={setDone} component={component} title={title} />
            }
            <Container
                maxWidth={false}
                sx={{
                    width: '100%',
                    backgroundColor: uiConfig.backgroundColor ? uiConfig.backgroundColor : 'palette.background',
                    padding: {xs: '.35rem 1rem', md: '.5rem 1rem'}
                }}
            >
                <Stack
                    direction='row'
                    spacing={10}
                    sx={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexWrap: 'wrap'
                    }}>
                    <Typography
                        style={{margin: '0'}}
                        sx={{
                            color: uiConfig.textColor ? uiConfig.textColor : 'sienna',
                            fontSize: {xs: '.7rem', md: '1rem'},
                            margin: '0',
                            lineHeight: {xs: '1.1rem', md: '1.4rem'},
                            padding: '0 2%',
                            textAlign: 'center'
                        }}
                    >
                        {uiConfig?.address ? parse(uiConfig.address) : ''}
                    </Typography>
                        <Typography
                            style={{margin: '0'}}
                            sx={{
                                color: uiConfig.textColor ? uiConfig.textColor : 'sienna',
                                fontSize: {xs: '.7rem', md: '1rem'},
                                lineHeight: {xs: '1.1rem', md: '1.4rem'},
                                padding: '0 2%'
                            }}
                        >
                            {uiConfig?.phone ? parse(uiConfig.phone) : ''}
                        </Typography>
                        <Typography
                            style={{margin: '0'}}
                            sx={{
                                color: uiConfig.textColor ? uiConfig.textColor : 'sienna',
                                fontSize: {xs: '.7rem', md: '1rem'},
                                margin: '0',
                                lineHeight: {xs: '1.1rem', md: '1.4rem'},
                                padding: '0 2%'
                            }}
                        >
                            {uiConfig?.email ? parse(uiConfig.email) : ''}
                        </Typography>
                </Stack>
                <Stack
                    direction='row'
                    spacing={5}
                    sx={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        marginTop: {xs: '.25rem', md: '.3rem'}
                    }}>
                    <Typography style={{margin: '0'}} sx={{fontSize: {xs: '.65rem', md: '.9rem'}, padding: '0 1.5%', cursor: 'pointer'}}>
                        <Link
                            href="#"
                            tabIndex={0}
                            underline="always"
                            aria-haspopup="dialog"
                            onClick={() => openPopup(ContactUs, 'Help & Contact')}
                            onKeyDown={(event) => handleKeyDown(event, ContactUs, 'Help & Contact')}
                            sx={{color: uiConfig.textColor ? uiConfig.textColor : 'text.secondary'}}
                        >
                            Help & Contact
                        </Link>
                    </Typography>
                    <Typography style={{margin: '0'}} sx={{fontSize: {xs: '.65rem', md: '.9rem'}, padding: '0 1.5%', cursor: 'pointer'}}>
                        <Link
                            href="#"
                            tabIndex={0}
                            underline="always"
                            aria-haspopup="dialog"
                            onClick={() => openPopup(TandC, 'Terms and Conditions')}
                            onKeyDown={(event) => handleKeyDown(event, TandC, 'Terms and Conditions')}
                            sx={{color: uiConfig.textColor ? uiConfig.textColor : 'text.secondary'}}
                        >
                            Terms and Conditions
                        </Link>
                    </Typography>
                    <Typography style={{margin: '0'}} sx={{fontSize: {xs: '.65rem', md: '.9rem'}, padding: '0 1.5%', cursor: 'pointer'}}>
                        <Link
                            href="#"
                            tabIndex={0}
                            underline="always"
                            aria-haspopup="dialog"
                            onClick={() => openPopup(Refund, 'Refunds / Credits')}
                            onKeyDown={(event) => handleKeyDown(event, Refund, 'Refunds / Credits')}
                            sx={{color: uiConfig.textColor ? uiConfig.textColor : 'text.secondary'}}
                        >
                            Refunds / Credits
                        </Link>
                    </Typography>
                    <Typography style={{margin: '0'}} sx={{fontSize: {xs: '.65rem', md: '.9rem'}, padding: '0 1.5%', cursor: 'pointer'}}>
                        <Link
                            href="#"
                            tabIndex={0}
                            underline="always"
                            aria-haspopup="dialog"
                            onClick={() => openPopup(Privacy, 'Privacy Policy')}
                            onKeyDown={(event) => handleKeyDown(event, Privacy, 'Privacy Policy')}
                            sx={{color: uiConfig.textColor ? uiConfig.textColor : 'text.secondary'}}
                        >
                            Privacy Policy
                        </Link>
                    </Typography>
                </Stack>
                <Stack
                    direction='row'
                    sx={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginTop: {xs: '.2rem', md: '.3rem'}
                    }}>
                    <Typography style={{fontSize: '.65rem'}} sx={{color: uiConfig.textColor ? uiConfig.textColor : 'text.primary'}}>© 2008-{`${new Date().getFullYear()}`} Justice Systems Inc.; Avenu Insights & Analytics LLC - All rights reserved.</Typography>
                </Stack>
            </Container>
        </>
    );
}

export default CustomFooter;
